import { render } from "./PageError.vue?vue&type=template&id=f8bb9392&scoped=true"
import script from "./PageError.vue?vue&type=script&lang=js"
export * from "./PageError.vue?vue&type=script&lang=js"

import "./PageError.vue?vue&type=style&index=0&id=f8bb9392&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8bb9392"]])

export default __exports__